import { Space, Tooltip, Typography } from 'antd';

import { RevenueCatIcon } from '@/components/monetization/RevenueCatIcon';
import { rcCustomerUrl, rcProductUrl } from '@/utils/monetization/revenuecat';

type RevenueCatLinkProps = {
  /** Identifier shown next to the icon. */
  id: string | number;
  /** Tooltip copy — resource specific, so callers pass their own key. */
  title: string;
  /** Inside a clickable table row, keep the row from reacting to the link. */
  stopRowClick?: boolean;
};

const RevenueCatLink = ({
  id,
  title,
  stopRowClick,
  href,
}: RevenueCatLinkProps & { href: string | null }) => (
  <Space size={8}>
    <span>{id}</span>
    {href && (
      <Tooltip title={title}>
        <Typography.Link
          href={href}
          target="_blank"
          rel="noreferrer"
          onClick={stopRowClick ? (e) => e.stopPropagation() : undefined}
        >
          <RevenueCatIcon />
        </Typography.Link>
      </Tooltip>
    )}
  </Space>
);

export const RevenueCatCustomerLink = (props: RevenueCatLinkProps) => (
  <RevenueCatLink {...props} href={rcCustomerUrl(props.id)} />
);

export const RevenueCatProductLink = (
  props: RevenueCatLinkProps & { id: string }
) => <RevenueCatLink {...props} href={rcProductUrl(props.id)} />;
